/**
 * Firebase Auth iframe / handler must share the page origin on custom Hosting
 * domains. When the SPA runs on amazing.wedding but authDomain still points at
 * *.firebaseapp.com, signInWithPopup's helper iframe is cross-origin and modern
 * browsers block the session hand-off — Google SSO spins or fails.
 *
 * @see https://firebase.google.com/docs/auth/web/redirect-best-practices#update-authdomain
 */

/** Custom Firebase Hosting domains wired in the console (not *.web.app). */
const CUSTOM_AUTH_DOMAINS = new Set(["amazing.wedding"]);

export function resolveAuthDomain(configured: string): string {
  if (typeof window === "undefined") return configured;
  const host = window.location.hostname;
  if (CUSTOM_AUTH_DOMAINS.has(host)) return host;
  if (host.endsWith(".amazing.wedding")) return "amazing.wedding";
  return configured;
}
